import { UmbracoTypes } from '~/lib/data-contract';
import { useFrame, usePage } from '~/services/umbraco/hooks';
import { Schema, SchemaTypes } from '~/shared/schema';
import DynamicBlocks from '~/templates/blocks';

export default function P160ArticlePage() {
    const { data: page } = usePage<UmbracoTypes.IP160ArticlePage>();
    const { data: frame } = useFrame();
    const { src: logo } = frame?.footer?.logoImage || {};

    const image = (page?.pageElements
        ?.flatMap((element) => element.image)
        .flatMap((image) => image?.src)
        .filter((element) => element) || []) as string[];

    return (
        <>
            <Schema
                type={SchemaTypes.Article}
                props={{
                    headline: page?.title,
                    image,
                    datePublished: page?.createDate?.toString(),
                    dateModified: page?.updateDate?.toString(),
                    logo,
                }}
            />

            <DynamicBlocks elements={page?.pageElements as UmbracoTypes.IModules[]} />
        </>
    );
}
